<section class="final-order section-padding bg-light-theme">
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-9">
        <div class="main-box padding-20">
          <!-- Empty Cart Message -->
          <div
            *ngIf="(storeCarts$ | async)?.length === 0"
            class="text-center py-5"
          >
            <h3 class="text-light-black mb-3">Your cart is empty</h3>
            <p class="text-light-white mb-4">
              Add services to your cart to continue
            </p>
            <a
              routerLink="/businesses"
              class="btn-first green-btn text-custom-white"
            >
              Browse Stores
            </a>
          </div>

          <!-- Order Details by Store -->
          <div
            *ngFor="
              let storeData of storeCheckoutDataArray$ | async;
              let storeIndex = index
            "
            class="mb-5"
          >
            <div class="row mb-xl-20">
              <div class="col-md-6">
                <div class="section-header-left">
                  <h4
                    class="text-light-black header-title fw-500"
                    *ngIf="storeIndex === 0"
                  >
                    Review and book appointment
                  </h4>
                  <h5
                    class="text-light-black fw-700 mt-3"
                    *ngIf="storeIndex > 0"
                  >
                    {{ storeData.storeCart.storeName || "Store" }}
                  </h5>
                </div>

                <!-- Store Information Skeleton -->
                <div *ngIf="storeData.isLoadingStore" class="mb-3">
                  <div class="skeleton-text" style="width: 150px; height: 20px; margin-bottom: 12px;"></div>
                  <div class="skeleton-text" style="width: 200px; height: 16px; margin-bottom: 8px;"></div>
                  <div class="skeleton-text" style="width: 250px; height: 16px; margin-bottom: 8px;"></div>
                  <div class="skeleton-text" style="width: 120px; height: 16px;"></div>
                </div>
                <div
                  *ngIf="!storeData.isLoadingStore && storeData.storeInfo"
                  class="mb-3"
                >
                  <h6 class="text-light-black fw-700 mb-2">
                    Store Information
                  </h6>
                  <p class="text-light-black fw-600 mb-1">
                    {{ storeData.storeInfo.storeName }}
                  </p>
                  <p class="text-light-white mb-1">
                    {{ storeData.storeInfo.address }}
                    <span *ngIf="storeData.storeInfo.address2"
                      >, {{ storeData.storeInfo.address2 }}</span
                    >
                    <br />
                    {{ storeData.storeInfo.city }},
                    {{ storeData.storeInfo.state }}
                    {{ storeData.storeInfo.zipCode }}
                  </p>
                  <p
                    class="text-light-white mb-1"
                    *ngIf="storeData.storeInfo.phoneNumber"
                  >
                    <i class="fas fa-phone"></i>
                    {{ storeData.storeInfo.phoneNumber }}
                  </p>
                </div>
                <div
                  *ngIf="!storeData.isLoadingStore && !storeData.storeInfo"
                  class="mb-3"
                >
                  <p class="text-light-white">
                    Store information not available
                  </p>
                </div>

                <!-- Appointment Date/Time Selection -->
                <div class="mb-4">
                  <h6 class="text-light-black fw-700 mb-2">
                    Appointment Details
                  </h6>

                  <!-- Date Selection -->
                  <div class="mb-3">
                    <label class="text-light-black fw-600 mb-2 d-block"
                      >Select Date</label
                    >
                    <input
                      type="date"
                      class="form-control form-control-submit"
                      [min]="getMinDate()"
                      [value]="
                        storeData.selectedDate
                          ? formatDateForInput(storeData.selectedDate)
                          : ''
                      "
                      (change)="
                        onDateChange(storeData.storeCart.storeId, $event)
                      "
                    />
                  </div>

                  <!-- Time Selection -->
                  <div *ngIf="storeData.selectedDate" class="mb-3">
                    <label class="text-light-black fw-600 mb-2 d-block"
                      >Available Times</label
                    >
                    <div
                      *ngIf="storeData.availableTimes.length === 0"
                      class="text-center p-3"
                    >
                      <p class="text-light-white fs-12 mb-0">
                        No available times for this date
                      </p>
                    </div>
                    <div
                      *ngIf="storeData.availableTimes.length > 0"
                      class="d-flex flex-wrap gap-2"
                    >
                      <button
                        *ngFor="let time of storeData.availableTimes"
                        type="button"
                        class="btn btn-sm"
                        [class.btn-primary]="storeData.selectedTime === time"
                        [class.btn-outline-primary]="
                          storeData.selectedTime !== time
                        "
                        (click)="
                          onTimeSelect(storeData.storeCart.storeId, time)
                        "
                        style="min-width: 80px"
                      >
                        {{ time }}
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Staff Information - Global (for backward compatibility) -->
                <div
                  *ngIf="
                    storeData.storeCart.items.length > 0 &&
                    storeData.storeCart.items[0].staffName &&
                    storeData.storeCart.items.length === 1
                  "
                  class="mb-3"
                >
                  <h6 class="text-light-black fw-700 mb-2">Staff</h6>
                  <p class="text-light-white mb-0">
                    {{ storeData.storeCart.items[0].staffName }}
                  </p>
                </div>
              </div>

              <!-- Store Images Swiper -->
              <div class="col-md-6">
                <div class="advertisement-img">
                  <div
                    *ngIf="
                      storeData.storeInfo &&
                      getStoreImages(storeData.storeInfo).length > 1
                    "
                    class="swiper-container store-image-swiper p-relative"
                    [id]="'store-swiper-' + storeData.storeCart.storeId"
                  >
                    <div class="swiper-wrapper">
                      <div
                        class="swiper-slide"
                        *ngFor="
                          let image of getStoreImages(storeData.storeInfo)
                        "
                      >
                        <img
                          [src]="image"
                          class="img-fluid full-width"
                          [alt]="storeData.storeInfo?.storeName || 'Store image'"
                        />
                      </div>
                    </div>
                    <!-- Add Pagination -->
                    <div
                      [class]="
                        'swiper-pagination swiper-pagination-' +
                        storeData.storeCart.storeId
                      "
                    ></div>
                    <!-- Add Navigation -->
                    <div
                      [class]="
                        'swiper-button-next swiper-button-next-' +
                        storeData.storeCart.storeId
                      "
                    ></div>
                    <div
                      [class]="
                        'swiper-button-prev swiper-button-prev-' +
                        storeData.storeCart.storeId
                      "
                    ></div>
                  </div>
                  <div
                    *ngIf="
                      !storeData.storeInfo ||
                      getStoreImages(storeData.storeInfo).length === 0
                    "
                    class="skeleton-image"
                    style="width: 100%; height: 300px; border-radius: 4px;"
                  ></div>
                </div>
              </div>
            </div>

            <!-- Service Combos and Items for this Store -->
            <div class="row mb-4">
              <div class="col-12">
                <h6 class="text-light-black fw-700 mb-3">Services</h6>
                <div
                  *ngFor="let item of storeData.storeCart.items"
                  class="mb-3 p-3 border rounded"
                >
                  <div class="d-flex justify-content-between align-items-start">
                    <div class="flex-grow-1">
                      <!-- Service Combos -->
                      <div *ngIf="item.combos && item.combos.length > 0">
                        <p class="text-light-black fw-600 mb-1">
                          Service Combos:
                        </p>
                        <ul class="list-unstyled mb-2">
                          <li
                            *ngFor="let combo of item.combos"
                            class="text-light-white mb-1"
                          >
                            <i class="fas fa-check text-light-green mr-2"></i>
                            {{ combo.name }}
                            <span class="text-light-white">
                              - {{ formatPrice(combo.totalPrice) }}</span
                            >
                            <span class="text-light-white">
                              ({{ formatDuration(combo.duration) }})</span
                            >
                          </li>
                        </ul>
                      </div>

                      <!-- Service Items -->
                      <div *ngIf="item.items && item.items.length > 0">
                        <p class="text-light-black fw-600 mb-1">
                          Service Items:
                        </p>
                        <ul class="list-unstyled mb-2">
                          <li
                            *ngFor="let serviceItem of item.items"
                            class="text-light-white mb-1"
                          >
                            <i class="fas fa-check text-light-green mr-2"></i>
                            {{ serviceItem.name }}
                            <span class="text-light-white">
                              - {{ formatPrice(serviceItem.totalPrice) }}</span
                            >
                            <span class="text-light-white">
                              ({{ formatDuration(serviceItem.duration) }})</span
                            >
                          </li>
                        </ul>
                      </div>

                      <!-- Appointment Time -->
                      <div *ngIf="item.startTime" class="mt-2">
                        <p class="text-light-white mb-0">
                          <i class="fas fa-calendar-alt mr-2"></i>
                          {{ item.date | date : "shortDate" }}
                          <span *ngIf="storeData.selectedTime" class="ml-2">
                            <i class="fas fa-clock mr-2"></i>
                            {{ storeData.selectedTime }}
                          </span>
                        </p>
                      </div>

                      <!-- Staff Selection -->
                      <div class="mt-2">
                        <label class="text-light-black fw-600 mb-2 d-block">
                          <i class="fas fa-user mr-2"></i>Select Staff
                        </label>
                        <select
                          class="form-control form-control-submit"
                          [ngModel]="item.staffId || ''"
                          (ngModelChange)="
                            onStaffChange(
                              storeData.storeCart.storeId,
                              item.id,
                              $event
                            )
                          "
                          [disabled]="
                            storeData.isLoadingStaff ||
                            storeData.isLoadingAvailability
                          "
                        >
                          <option [ngValue]="''">
                            No preference (Any available staff)
                          </option>
                          <optgroup
                            label="Available Staff"
                            *ngIf="
                              storeData.selectedDate &&
                              storeData.selectedTime &&
                              getAvailableStaff(storeData, item.id).length > 0
                            "
                          >
                            <option
                              *ngFor="
                                let staff of getAvailableStaff(
                                  storeData,
                                  item.id
                                )
                              "
                              [ngValue]="staff.id"
                              [disabled]="
                                item.staffId === staff.id &&
                                (!isStaffWorkingAtTime(
                                  staff,
                                  storeData.selectedDate,
                                  storeData.selectedTime,
                                  item.duration
                                ) ||
                                  storeData.staffAvailability.get(staff.id) ===
                                    false)
                              "
                            >
                              {{ getStaffDisplayName(staff) }}
                              <span
                                *ngIf="
                                  item.staffId === staff.id &&
                                  !isStaffWorkingAtTime(
                                    staff,
                                    storeData.selectedDate,
                                    storeData.selectedTime,
                                    item.duration
                                  )
                                "
                              >
                                (Not working)</span
                              >
                              <span
                                *ngIf="
                                  item.staffId === staff.id &&
                                  isStaffWorkingAtTime(
                                    staff,
                                    storeData.selectedDate,
                                    storeData.selectedTime,
                                    item.duration
                                  ) &&
                                  storeData.staffAvailability.get(staff.id) ===
                                    false
                                "
                              >
                                (Busy)</span
                              >
                            </option>
                          </optgroup>
                          <optgroup
                            label="All Staff"
                            *ngIf="
                              !storeData.selectedDate || !storeData.selectedTime
                            "
                          >
                            <option
                              *ngFor="let staff of storeData.staffList"
                              [ngValue]="staff.id"
                            >
                              {{ getStaffDisplayName(staff) }}
                            </option>
                          </optgroup>
                          <optgroup
                            label="Unavailable Staff"
                            *ngIf="
                              hasUnavailableStaff(storeData, item.id) &&
                              (!item.staffId ||
                                !isSelectedStaffInAvailableList(
                                  storeData,
                                  item.id
                                ))
                            "
                          >
                            <option
                              *ngFor="
                                let staff of getUnavailableStaff(
                                  storeData,
                                  item.id
                                )
                              "
                              [ngValue]="staff.id"
                              [disabled]="item.staffId !== staff.id"
                            >
                              {{ getStaffDisplayName(staff) }}
                              <span
                                *ngIf="
                                  !isStaffWorkingAtTime(
                                    staff,
                                    storeData.selectedDate,
                                    storeData.selectedTime,
                                    item.duration
                                  )
                                "
                                >(Not working)</span
                              >
                              <span
                                *ngIf="
                                  isStaffWorkingAtTime(
                                    staff,
                                    storeData.selectedDate,
                                    storeData.selectedTime,
                                    item.duration
                                  ) &&
                                  storeData.staffAvailability.get(staff.id) ===
                                    false
                                "
                                >(Busy)</span
                              >
                            </option>
                          </optgroup>
                        </select>
                        <small
                          class="text-light-white fs-12 d-block mt-1"
                          *ngIf="storeData.isLoadingStaff"
                        >
                          Loading staff...
                        </small>
                        <small
                          class="text-light-white fs-12 d-block mt-1"
                          *ngIf="
                            storeData.isLoadingAvailability &&
                            !storeData.isLoadingStaff
                          "
                        >
                          Checking staff availability...
                        </small>
                        <small
                          class="text-light-white fs-12 d-block mt-1"
                          *ngIf="
                            !storeData.isLoadingStaff &&
                            storeData.staffList.length === 0
                          "
                        >
                          No staff available for this store
                        </small>
                        <small
                          class="text-warning fs-12 d-block mt-1"
                          *ngIf="
                            storeData.selectedDate &&
                            storeData.selectedTime &&
                            !storeData.isLoadingAvailability &&
                            !storeData.isLoadingStaff &&
                            getAvailableStaff(storeData, item.id).length ===
                              0 &&
                            storeData.staffList.length > 0
                          "
                        >
                          No staff available at this time. Staff may be off-duty
                          or have existing appointments. Please select a
                          different time.
                        </small>
                        <small
                          class="text-danger fs-12 d-block mt-1"
                          *ngIf="
                            item.staffId &&
                            storeData.selectedDate &&
                            storeData.selectedTime &&
                            !storeData.isLoadingAvailability &&
                            !isStaffAvailableForItem(storeData, item)
                          "
                        >
                          <i class="fas fa-exclamation-triangle mr-1"></i>
                          <span
                            *ngIf="isSelectedStaffNotWorking(storeData, item)"
                          >
                            Selected staff is not working at this time. Please
                            select a different staff or time.
                          </span>
                          <span
                            *ngIf="
                              !isSelectedStaffNotWorking(storeData, item) &&
                              isSelectedStaffBusy(storeData, item)
                            "
                          >
                            Selected staff is busy at this time. Please select a
                            different staff or time.
                          </span>
                        </small>
                      </div>

                      <!-- Total for this item -->
                      <div class="mt-2">
                        <p class="text-light-black fw-600 mb-0">
                          Total: {{ formatPrice(item.totalPrice) }}
                          <span class="text-light-white">
                            ({{ formatDuration(item.duration) }})</span
                          >
                        </p>
                      </div>
                    </div>
                    <div>
                      <button
                        class="btn btn-sm btn-outline-danger"
                        (click)="
                          removeCartItem(storeData.storeCart.storeId, item.id)
                        "
                        title="Remove item"
                      >
                        <i class="far fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <button
              type="submit"
              *ngIf="(storeCarts$ | async)?.length > 0"
              [disabled]="!canBookAppointments()"
              class="btn btn-primary text-custom-white full-width fw-500"
              (click)="bookAppointments()"
            >
              <span *ngIf="!isBooking">Book Appointments</span>
              <span *ngIf="isBooking">
                <i class="fas fa-spinner fa-spin mr-2"></i>Booking...
              </span>
            </button>
          </div>
        </div>
      </div>
      <div class="col-lg-3">
        <div class="sidebar">
          <div class="cart-detail-box">
            <div class="card">
              <div class="card-header padding-15 fw-700">
                Your Appointments
                <p
                  class="text-light-white no-margin fw-500"
                  *ngIf="getTotalItemCount() | async as itemCount"
                >
                  {{ itemCount }} {{ itemCount === 1 ? "item" : "items" }}
                </p>
              </div>
              <div class="card-body no-padding" id="scrollstyle-4">
                <!-- Cart Items by Store -->
                <ng-container
                  *ngFor="let storeData of storeCheckoutDataArray$ | async"
                >
                  <div
                    class="cat-product-box"
                    *ngIf="storeData.storeCart.storeName"
                  >
                    <div class="p-2 border-bottom">
                      <p class="text-light-black fw-700 mb-1">
                        {{ storeData.storeCart.storeName }}
                      </p>
                      <p
                        class="text-light-white fs-12 mb-0"
                        *ngIf="storeData.storeInfo"
                      >
                        {{ storeData.storeInfo.city }},
                        {{ storeData.storeInfo.state }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="cat-product-box"
                    *ngFor="let item of storeData.storeCart.items"
                  >
                    <div class="cat-product">
                      <div class="cat-name">
                        <p class="text-light-green fw-700 mb-1">
                          <span class="text-dark-white">1</span>
                          <span *ngIf="item.combos && item.combos.length > 0">
                            {{ item.combos[0].name }}
                          </span>
                          <span
                            *ngIf="!item.combos || item.combos.length === 0"
                          >
                            Service Appointment
                          </span>
                        </p>
                        <span
                          class="text-light-white fw-700 fs-12 d-block"
                          *ngIf="item.combos && item.combos.length > 1"
                        >
                          +{{ item.combos.length - 1 }} more combo{{
                            item.combos.length - 1 > 1 ? "s" : ""
                          }}
                        </span>
                        <span
                          class="text-light-white fw-700 fs-12 d-block"
                          *ngIf="item.items && item.items.length > 0"
                        >
                          {{ item.items.length }} service item{{
                            item.items.length > 1 ? "s" : ""
                          }}
                        </span>
                        <span
                          class="text-light-white fs-12 d-block"
                          *ngIf="storeData.selectedDate"
                        >
                          {{ storeData.selectedDate | date : "shortDate" }}
                          <span *ngIf="storeData.selectedTime">
                            at {{ storeData.selectedTime }}</span
                          >
                        </span>
                        <span
                          class="text-light-white fs-12 d-block mt-1"
                          *ngIf="item.staffName"
                        >
                          <i class="fas fa-user mr-1"></i>{{ item.staffName }}
                        </span>
                        <span
                          class="text-light-white fs-12 d-block mt-1"
                          *ngIf="!item.staffName"
                        >
                          <i class="fas fa-user mr-1"></i>Any available staff
                        </span>
                      </div>
                      <div class="delete-btn">
                        <a
                          (click)="
                            removeCartItem(storeData.storeCart.storeId, item.id)
                          "
                          class="text-dark-white"
                          style="cursor: pointer"
                        >
                          <i class="far fa-trash-alt"></i>
                        </a>
                      </div>
                      <div class="price">
                        <span class="text-dark-white fw-500">
                          {{ formatPrice(item.totalPrice) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <!-- Empty Cart Message -->
                <div
                  *ngIf="(storeCarts$ | async)?.length === 0"
                  class="text-center p-4"
                >
                  <p class="text-light-white">Your cart is empty</p>
                </div>

                <!-- Totals -->
                <div
                  class="item-total"
                  *ngIf="(storeCarts$ | async)?.length > 0"
                >
                  <div class="total-price border-0 pb-0">
                    <span class="text-dark-white fw-600">Items subtotal:</span>
                    <span class="text-dark-white fw-600">
                      {{ getTotalPrice() | async | currency : "USD" }}
                    </span>
                  </div>
                  <div class="total-price border-0">
                    <span class="text-light-black fw-700">Total:</span>
                    <span class="text-light-black fw-700">
                      {{ getTotalPrice() | async | currency : "USD" }}
                    </span>
                  </div>
                </div>
              </div>
              <div
                class="card-footer p-0 modify-order"
                *ngIf="(storeCarts$ | async)?.length > 0"
              >
                <button
                  class="text-custom-white full-width fw-500 bg-light-green mb-2"
                  routerLink="/businesses"
                >
                  <i class="fas fa-chevron-left mr-2"></i> Modify Your Order
                </button>
                <button
                  class="text-custom-white full-width fw-500 mb-2"
                  [class.bg-success]="canBookAppointments()"
                  [class.bg-secondary]="!canBookAppointments()"
                  [disabled]="!canBookAppointments()"
                  (click)="bookAppointments()"
                >
                  <i class="fas fa-calendar-check mr-2"></i>
                  <span *ngIf="!isBooking">Book Appointments</span>
                  <span *ngIf="isBooking">
                    <i class="fas fa-spinner fa-spin mr-2"></i>Booking...
                  </span>
                </button>
                <div class="total-amount">
                  <span class="text-custom-white fw-700">TOTAL</span>
                  <span class="text-custom-white fw-700">
                    {{ getTotalPrice() | async | currency : "USD" }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
